import React, { useRef, useState } from "react";
import clear from "../../assets/img/clear-24px.svg";
import "./titled-modal.css";

export default function TitledModal({ title, children, onClose }) {
  const overlayRef = useRef(null);
  const [downTarget, setDownTarget] = useState("");

  return (
    <div
      ref={overlayRef}
      className="titled-modal"
      onMouseDown={(e) => setDownTarget(e.target)}
      onMouseUp={(e) => {
        if (e.target !== overlayRef.current) return;
        if (downTarget !== overlayRef.current) return;
        onClose();
      }}
    >
      <div className="modal-content">
        <img
          className="close-modal-cross-btn"
          onClick={onClose}
          src={clear}
          alt="close modal"
        />
        <h3 className="modal-title">{title}</h3>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
}

